import React from 'react'
import './styles.scss'
const nf = new Intl.NumberFormat('de-CH')

export const AllCases = ({ data }: { data: sumData }) => {
  const { cases, death } = data
  return (
    <div className='allCases'>
      {data && (
        <table>
          <tbody>
            <tr className='key'>
              <td>&nbsp;</td>
              <td>Fälle</td>
              <td>Tote</td>
            </tr>
            <tr>
              <td className='label'>Total</td>
              <td className='cases'>
                {+cases > 9999 ? nf.format(+cases) : +cases}
              </td>
              <td className='death'>
                {+death > 9999 ? nf.format(+death) : +death}
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  )
}
